module.exports = __webpack_public_path__ + "img/new_knowledge.e87083f2.png";